import { gql } from 'apollo-boost';

export const ruleTriggerOptions = gql`
query {
  ruleTriggerOptions {
    dbId
    name
    ruleTrigger
  }
}
`;
